export const environment: any = {
  production: true,
  apiURL: 'https://api.dev.analytics.cimalti.jabyl.xyz'
};